"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var reduxStores_1 = __importDefault(require("@src/reduxStores"));
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var _utils_1 = require("@src/actions/_utils");
var SideMenu_1 = __importDefault(require("./components/SideMenu"));
var constants_1 = require("./constants");
var Header_1 = __importDefault(require("./containers/Header"));
var GeneralSettings_1 = __importDefault(require("./containers/GeneralSettings"));
var ContentManagement_1 = __importDefault(require("./containers/ContentManagement"));
var Channels_1 = __importDefault(require("./containers/Channels"));
var BotPrompt_1 = __importDefault(require("./containers/BotPrompt"));
var CommercePlus_1 = __importDefault(require("./containers/CommercePlus"));
var GenAiSalesAssistant_1 = __importDefault(require("./containers/GenAiSalesAssistant/GenAiSalesAssistant"));
var maps_1 = require("./maps");
require("./BusinessManagerV2.scss");
var defaults = {
    id: undefined,
};
var BusinessManagerV2 = function (_a) {
    var id = (_a === void 0 ? defaults : _a).id;
    var setBusinessId = maps_1.dispatchToProps(react_redux_1.useDispatch()).setBusinessId;
    var businessId = react_redux_1.useSelector(maps_1.stateToProps).businessId;
    var _b = react_1["default"].useState(constants_1.TAB_PATHS.GENERAL_SETTINGS), activeTab = _b[0], setActiveTab = _b[1];
    var currentDomainInStore = CommonStore_1["default"].getMetaTags().domain;
    react_1["default"].useEffect(function () {
        setBusinessId(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react_1["default"].useEffect(function () {
        if (currentDomainInStore) {
            _utils_1.verifyEnableGenAiSalesAssistant(currentDomainInStore.title);
            _utils_1.verifyEnableContextualBotBreak(currentDomainInStore.title);
        }
    }, [currentDomainInStore.id]);
    var setTab = function (newTab) {
        setActiveTab(newTab);
    };
    var renderActiveTab = react_1["default"].useCallback(function () {
        switch (activeTab) {
            case constants_1.TAB_PATHS.GENERAL_SETTINGS:
                return react_1["default"].createElement(GeneralSettings_1["default"], null);
            case constants_1.TAB_PATHS.CONTENT_MANAGEMENT:
                return react_1["default"].createElement(ContentManagement_1["default"], null);
            case constants_1.TAB_PATHS.CHANNELS:
                return react_1["default"].createElement(Channels_1["default"], null);
            case constants_1.TAB_PATHS.BOT_PROMPT:
                return react_1["default"].createElement(BotPrompt_1["default"], null);
            case constants_1.TAB_PATHS.COMMERCE_PLUS:
                return react_1["default"].createElement(CommercePlus_1["default"], null);
            case constants_1.TAB_PATHS.GEN_AI_SALES_ASSISTANT:
                return react_1["default"].createElement(GenAiSalesAssistant_1["default"], null);
            default:
                return null;
        }
    }, [activeTab]);
    return (react_1["default"].createElement("div", { className: "businessManager" },
        react_1["default"].createElement(Header_1["default"], null),
        businessId === id ? (react_1["default"].createElement("div", { className: "businessManagerBody" },
            react_1["default"].createElement(SideMenu_1["default"], { activeTab: activeTab, handleTabChange: setTab }),
            react_1["default"].createElement("div", { className: "businessManagerContent" }, renderActiveTab()))) : (react_1["default"].createElement("div", { className: "businessManagerEmptyState" }, "Data not available. Try reopening business from business list page."))));
};
var renderBusinessManager = function (_a) {
    var id = (_a === void 0 ? defaults : _a).id;
    return (react_1["default"].createElement(react_redux_1.Provider, { store: reduxStores_1["default"] },
        react_1["default"].createElement(BusinessManagerV2, { id: id })));
};
exports["default"] = renderBusinessManager;
